import DayjsUtils from '@date-io/dayjs';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { MSALProvider } from 'auth/msalProvider';
import SnackProvider from 'components/Snackbar/SnackProvider';
import Layout from 'modules/Layout';
import Routes from 'routes';
import PostalCodesLoader from 'utils/postalCodes/PostalCodesLoader';
import ScrollToTop from 'utils/router/scrollToTop';
import i18n from './i18n/config/i18n';
import theme from './style/theme';
const App = () => {
  return /*#__PURE__*/React.createElement(MSALProvider, null, /*#__PURE__*/React.createElement(CookiesProvider, null, /*#__PURE__*/React.createElement(RecoilRoot, null, /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18n
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(SnackProvider, null, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: DayjsUtils
  }, /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(PostalCodesLoader, null), /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Routes, null))))))))));
};
export default App;